module.exports = __webpack_public_path__ + "static/img/page1.cb98b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page1.jpg
// module id = pEwU
// module chunks = 1